/** Tags */
import { ADD_TAG_TO_MEMBER, CREATE_TAG, DELETE_TAG, EDIT_TAG, GET_TAGS } from './tag.types';

export const getTags = (params) => {
    return {
        type: GET_TAGS,
        payload: { params },
    };
};

/** `assignBody` is the same shape addTagToMember takes; the saga only prepends the created tag's id. */
export const createTag = (body, params, userInfo, requestParams, assignBody) => {
    return {
        type: CREATE_TAG,
        payload: { body, params, userInfo, requestParams, assignBody },
    };
};

export const editTag = (body, params, requestParams) => {
    return {
        type: EDIT_TAG,
        payload: { body, params, requestParams },
    };
};

export const deleteTag = (id, module, requestParams) => {
    return {
        type: DELETE_TAG,
        payload: { id, module, requestParams },
    };
};

/** End */

/** Tag for members */
export const addTagToMember = (id, body, requestParams, module) => {
    return {
        type: ADD_TAG_TO_MEMBER,
        payload: { id, body, requestParams, module },
    };
};

/** End */
